/* eslint-disable prefer-destructuring */
import React, { Component, Fragment } from 'react';
import { graphql, compose, withApollo } from 'react-apollo';
import Masonry from 'react-masonry-component';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Utils from '../../../utils';
import Banner from '../../../components/Banner/index';
import Footer from '../../../components/Footer/index';
import ARTISTS_PAGINATION_QUERY from '../../../graphql/ArtistPagination';
import ARTISTS_STATS_QUERY from '../../../graphql/ArtistStats';
import SearchBar from '../../../components/SearchBar/index';
import Pagination from '../../../components/Pagination';
import { ArtistCard } from '../../../components/Cards';
import KeyToProfession from '../../../transforms/KeyToProfession';
import { getFilterableProfessions } from '../../../constants';

const TABLE = 'table';
const CARDS = 'cards';

const DEFAULT_PROFESSION = 'singer';
let PAGE_LIMIT = sessionStorage.getItem('limit') || 9;
const SAVED_PROFESSION = Utils.getUrlParameter('prof') || DEFAULT_PROFESSION;
const SAVED_SPECIALTY = Utils.getUrlParameter('spec') || '';
const SAVED_FILTER = Utils.getUrlParameter('filter') || '';

// 1. Cantantes / Singer
// 2. Músicos / Musician
// 3. Bailarines / Dancer
// 4. Director Orquesta / Music Director
// 5. Director Escena / Stage Director
// 6. Compositor / Composer
// 7. Coreógrafo / Choreographer
// 8. Diseñador Luces / Light Designer
// 9. Diseñador Vestuario / Costume Designer
// 10. Escenógrafo / Stage Designer
// 11. Diseñador Multimedia / Multimedia Designer
// 12. Maquillador / Makeup artist
class ArtistsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showType: sessionStorage.getItem('escenaArtistsView') || CARDS,
    };
    this.setPageLimit();
  }

  onSearch = terms =>
    this.props.history.push({
      pathname: '/search/artists',
      state: terms,
    });

  setViewType = (type) => {
    sessionStorage.setItem('escenaArtistsView', type);
    this.setPageLimit();
    window.location.reload();
  };

  setProfession = (profession) => {
    window.location.href = `/artists?prof=${profession}`;
  };

  setSpecialty = (specialty) => {
    sessionStorage.setItem('spec', specialty);
    window.location.href = `/artists?spec=${specialty}`;
  };

  setFilter = (filter) => {
    window.location.href = `/artists?prof=${filter.profession}&spec=${
      filter.specialty
    }&filter=${filter.id}`;
  };

  setPageLimit = () => {
    const type = sessionStorage.getItem('escenaArtistsView') || CARDS;
    if (type === TABLE) PAGE_LIMIT = 20;
    else PAGE_LIMIT = 9;
    sessionStorage.setItem('limit', PAGE_LIMIT);
  };

  getArtistSpecialtyCount = ({ profession, specialty }) => {
    const stats = this.props.artistStats;
    if (!stats || stats.length === 0) {
      return 0;
    }
    let stat;

    if (profession) {
      stat = stats
        .filter(s => s.profession != null)
        .filter(s => s.profession.toLowerCase() === profession.toLowerCase())[0];
    }
    if (specialty) {
      stat = stats
        .filter(s => s.specialty != null)
        .filter(s => s.specialty.toLowerCase() === specialty.toLowerCase())[0];
    }

    if (!stat) {
      return 0;
    }

    return stat.count;
  };

  getParams = () => {
    const prof = Utils.getUrlParameter('prof');
    const spec = Utils.getUrlParameter('spec');
    const filter = Utils.getUrlParameter('filter');
    let ret = '?';
    if (prof) ret += `prof=${prof}&`;
    if (spec) ret += `spec=${spec}&`;
    if (filter) ret += `filter=${filter}`;
    return ret;
  }

  getShowableCategories = () =>
    getFilterableProfessions().filter(s => this.getArtistSpecialtyCount(s) > 0);

  seeArtist = cell => (
    <div>
      <a href={`/artist/${cell}`}>Ver ficha</a>
    </div>
  );

  shoulRenderSquareNavigation = () => SAVED_FILTER === '';

  cleanFilters = () => {
    window.location.href = '/artists';
  };

  renderSquaresNavigation = () => (
    <div className="row">
      <div className="filters-row">
        {this.getShowableCategories().map(s => (
          <div
            onClick={() => this.setFilter(s)}
            className={`artist-filter-btn ${
              SAVED_FILTER == s.id ? 'active' : ''
            }`}
          >
            <div
              className="image"
              style={{ backgroundImage: `url(${s.pictureUrl})` }}
            />
            <div className="f-label">
              {s.label}&nbsp;
              ({this.getArtistSpecialtyCount(s)})
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  renderSideNavigation = () => (
    <div>
      <div className="col-xs-2">
        <ul className="filters-row-list">
          {this.getShowableCategories().map((s, index) => (
            <li
              onClick={() => this.setFilter(s)}
              onKeyDown={() => this.setFilter(s)}
              className={`${SAVED_FILTER == s.id ? 'active' : ''}`}
            >
              {s.label}&nbsp; ({this.getArtistSpecialtyCount(s)})
            </li>
          ))}
          <span onClick={this.cleanFilters} onKeyDown={this.cleanFilters}>
            Limpiar
          </span>
        </ul>
      </div>
      <div>
        <div className="filters-row-mobile d-none">
          {this.getShowableCategories().map(s => (
            <div
              onClick={() => this.setFilter(s)}
              onKeyDown={() => this.setFilter(s)}
              className={`mobile-button ${
                SAVED_FILTER == s.id ? 'active' : ''
              }`}
            >
              {s.label}&nbsp; ({this.getArtistSpecialtyCount(s)})
            </div>
          ))}
          <span onClick={this.cleanFilters}>
            Limpiar
          </span>
        </div>
      </div>
    </div>
  );

  render() {
    const childElementsCards = (this.props.artists || []).map(artist => (
      <ArtistCard key={artist.id} artist={artist} />
    ));

    const { showType } = this.state;

    const artistsTransformed = this.props.artists.map((a) => {
      a.completename = `${a.name} ${a.lastname}`;
      a.shortDesc = `${KeyToProfession(a.profession)} ${a.specialty && `- ${a.specialty}`}`;
      return a;
    });

    const childElementsTable = (
      <BootstrapTable data={artistsTransformed || []} striped hover>
        <TableHeaderColumn isKey dataField="id" dataSort hidden>
          ID
        </TableHeaderColumn>
        <TableHeaderColumn dataField="completename">Nombre</TableHeaderColumn>
        <TableHeaderColumn dataField="shortDesc">
          Especialidad
        </TableHeaderColumn>
        <TableHeaderColumn dataField="nationality">
          País
        </TableHeaderColumn>
        <TableHeaderColumn dataFormat={this.seeArtist} dataField="slug">
          Acciones
        </TableHeaderColumn>
      </BootstrapTable>
    );

    return (
      <Fragment>
        <Banner />
        <div className="recent-properties artists-table">
          <div className="container">
            <div className="main-title">
              <h1>Artistas</h1>
              <div className="border">
                <div className="border-inner" />
              </div>
            </div>
            <div className="row mb-40">
              <SearchBar onSearch={this.onSearch} artists />
            </div>
            {!this.shoulRenderSquareNavigation() && (
              <div className="row grid-buttons d-flex">
                Ver:&nbsp;&nbsp;
                <buton
                  onClick={() => this.setViewType(TABLE)}
                  onKeyDown={() => this.setViewType(TABLE)}
                >
                  <i
                    className={`fa fa-list ${
                      showType === TABLE ? 'active' : ''
                    }`}
                  />
                </buton>
                <buton
                  onClick={() => this.setViewType(CARDS)}
                  onKeyDown={() => this.setViewType(CARDS)}
                >
                  <i
                    className={`fa fa-th ${showType === CARDS ? 'active' : ''}`}
                  />
                </buton>
              </div>
            )}
            {this.shoulRenderSquareNavigation() &&
              this.renderSquaresNavigation()}
            {!this.shoulRenderSquareNavigation() && (
              <div className="row m-t-md">
                {this.renderSideNavigation()}
                <div className="col-xs-12 col-sm-10">
                  <Masonry
                    className="artists-content" // default ''
                    options={{
                      transitionDuration: 0,
                    }}
                  >
                    {showType === TABLE && childElementsTable}
                    {showType === CARDS && childElementsCards}
                  </Masonry>
                </div>
              </div>
            )}
            {!this.shoulRenderSquareNavigation() && (
              <div className="row">
                <div className="col-md-12">
                  <Pagination
                    url="/artists"
                    pages={this.props.pages}
                    currentPage={this.props.current}
                    params={this.getParams()}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <Footer />
      </Fragment>
    );
  }
}

const withArtists = graphql(ARTISTS_PAGINATION_QUERY, {
  props: ({ data }) => {
    const pagination = data.artistPagination || {};
    return {
      loading: data.loading,
      artists: pagination.artists || [],
      total: pagination.count || 0,
      pages: pagination.pages || 1,
      current: pagination.currentPage || 1,
    };
  },
  options: ({ match }) => ({
    fetchPolicy: 'cache-and-network',
    variables: {
      page: Number.parseInt(match.params.page, 10) || 1,
      limit: Number.parseInt(PAGE_LIMIT, 10),
      profession: SAVED_PROFESSION,
      specialty: SAVED_SPECIALTY,
    },
  }),
});

const withArtistStats = graphql(ARTISTS_STATS_QUERY, {
  props: ({ data }) => ({ artistStats: data.artistStats }),
  options: () => ({
    fetchPolicy: 'cache-and-network',
  }),
});

export default compose(
  withApollo,
  withArtists,
  withArtistStats,
)(ArtistsPage);



// WEBPACK FOOTER //
// ./src/containers/General/ArtistsPage/index.js